<template>
  <div class="customer-container">
    <v-toolbar
      flat
      dense
      color="white"
      height="56px"
    >
      <v-btn
        icon
        @click="activeCustomerId = null"
      >
        <v-icon color="primary">arrow_forward</v-icon>
      </v-btn>
      <v-toolbar-title>{{ customer.name || 'ללא שם' }}</v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn
        small
        @click="edit({ entityId: activeCustomerId })"
      >
        <v-icon small>edit</v-icon> עריכת פרטי מחולצ/ת
      </v-btn>
    </v-toolbar>

    <v-divider />

    <v-data-table
      :items="customerData"
      hide-actions
      hide-headers
    >
      <template v-slot:items="props">
        <td class="font-weight-bold text-xs-right">{{ props.item.name }}</td>
        <td class="text-xs-right">
          {{ displayFunction(props.item.key, props.item.value) }}
        </td>
      </template>
    </v-data-table>

    <v-sheet
      v-if="customer.description"
      class="pa-4"
    >
      <vue-markdown :source="customer.description || 'אין מידע'"></vue-markdown>
    </v-sheet>

    <v-divider />

    <contact-details-list
      :contact-details-data="contactDetails"
      :parent-resource="$store.state.resources.customer"
      :parent-id="activeCustomerId"
      :roles="['ADMIN', 'EVENT_MANAGER', 'RESEARCHER']"
    />

    <v-btn
      small
      @click="createContactDetail"
      v-if="shouldShow(['ADMIN', 'EVENT_MANAGER'], user)"
      class="mt-2 mb-4"
    >
      <v-icon>add</v-icon> הוספת פרט קשר
    </v-btn>

  </div>
</template>

<script>
import generateId from "@/idGenerator";
import shouldShow from "@/utils/shouldShow";
import VueMarkdown from "vue-markdown";

import ContactDetailsList from "../../../ContactDetailsList.vue";

export default {
  data() {
    return {
      removing: []
    };
  },

  computed: {
    customer() {
      return this.$store.state.entities.customers[this.activeCustomerId];
    },
    activeCustomerId: {
      get() {
        return this.$store.getters["customers/activeCustomersIds"][this.compId];
      },
      set(payload) {
        this.$store.commit("customers/SET_ACTIVE_CUSTOMER_ID", {
          compId: this.compId,
          payload
        });
      }
    },
    resource() {
      return this.$store.state.resources.customer;
    },
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    },
    user() {
      return this.$store.getters["user/user"];
    },
    customerData() {
      debugger;
      let data = [];
      if (this.resource) {
        let model = this.resource.model;
        for (let key of Object.keys(model)) {
          if (!model[key].hidden && model[key].type !== "TEXTAREA") {
            if (this.customer[key] === false || this.customer[key]) {
              if (key === 'passport') {
                // Push passport part
                if(this.customer["phone"]!=undefined){
                data.push({
                  key,
                  name: model[key].name,
                  value: this.customer[key].split(';')[0]+";"+this.customer["phone"]
                });
                }
                else{
                  data.push({
                    key,
                    name: model[key].name,
                    value: this.customer[key].split(';')[0]
                  });
                }
                // Push phone part
                // Check if phone field exists in model, otherwise use nameEn (which is labeled as טלפון)
                const phoneFieldName = model['phone'] ? model['phone'].name : (model['nameEn'] ? model['nameEn'].name : 'טלפון');
                data.push({
                  key: 'phone',
                  name: phoneFieldName,
                  value: this.customer[key].split(';')[1] || ''
                });
              } else if (key !== 'phone') { // Skip phone field since we handle it with passport
                data.push({
                  key,
                  name: model[key].name,
                  value: this.customer[key]
                });
              }
            }
          }
        }
      }
      return data;
    },
    contactDetails() {
      return this.$store.getters["customers/contactDetails"](
        this.activeCustomerId
      );
    }
  },
  methods: {
    shouldShow,
    edit({ entity, entityId, isNew = false }) {
      debugger;
      if (!entity) {
        entity = this.$store.state.entities[this.resource.entityType][entityId];
      }
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: this.resource.schema
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource: this.resource,
        isNew
      });
      this.entityEditDialog = true;
    },
    displayFunction(key, value) {
      let model = this.resource.model;
      if (model[key].type === "BOOLEAN") {
        return value ? "כן" : "לא";
      } else if (model[key].type === "SELECT") {
        let item = this.$store.state.entities[model[key].items][
          value._id || value
        ];
        if (item) {
          return item[model[key].itemText];
        } else {
          return "לא ידוע";
        }
      } else {
        return value;
      }
    },
    createContactDetail() {
      let newEntity = { _id: generateId(), customer: this.activeCustomerId };
      this.editContactDetail(newEntity, true);
    },
    editContactDetail(entity, isNew = false) {
      let resource = this.$store.state.resources.contactDetail;
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: resource.schema
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource,
        isNew
      });
      this.entityEditDialog = true;
    }
  },
  mounted() {},

  props: ["compId"],

  components: {
    VueMarkdown,
    ContactDetailsList
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.customer-container .v-toolbar__content {
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/events/modules/Customers/Customer.vue